exports.ClientsPageView = require('./ClientsPageView').default;
exports.ClientsCreatePageView = require('./ClientsCreatePageView').default;
exports.ClientsDetailPageView = require('./ClientsDetailPageView').default;
